import { render, staticRenderFns } from "./竞价项目.vue?vue&type=template&id=5abf07e0&scoped=true"
import script from "./竞价项目.vue?vue&type=script&lang=js"
export * from "./竞价项目.vue?vue&type=script&lang=js"
import style0 from "./竞价项目.vue?vue&type=style&index=0&id=5abf07e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abf07e0",
  null
  
)

export default component.exports